module.exports = __webpack_public_path__ + "static/media/EmailVerificationSuccess.9998155b.svg";